<template>
    <div class="stf-sub-heading">
        <slot />
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped lang="scss">
@use '@/assets/sass/_variables' as vars;
@use "bulma/sass/utilities/mixins";

.stf-sub-heading {
  display: inline-block;
  font-family: vars.$font-family-primary;
  font-weight: vars.$font-weight-semibold;
  font-size: vars.$font-size-17;
  letter-spacing: -0.02em;
  color: #414141;

  @include mixins.mobile {
    font-size: vars.$font-size-14;
  }
}
</style>
